import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { selectTheme } from "stateMgmt/appSlice";

const setFocus = () => {
  const header = document.getElementById("page-header");
  if (header) {
    header.focus();
  }
};

const ScrollToTopButton = (props) => {
  const theme = useSelector(selectTheme);
  setFocus();
  return (
    <a
      href={`#${props.scrollToTopLocation}`}
      aria-label="Scroll to top of page button"
    >
      <i
        className="fas fa-chevron-up scroll-to-top__button float-right"
        style={{
          backgroundColor: theme.buttonColor,
          color: theme.backgroundColor,
          borderColor: theme.color
        }}
      ></i>
    </a>
  );
};

ScrollToTopButton.propTypes = {
  scrollToTopLocation: PropTypes.string,
};

export default ScrollToTopButton;
